/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// GROUP
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
const tipSpaceSize = 7;
export default theme => ({
	tip: {
		// check app_styles for more '.tippy-tooltip'
		color: `rgba(6, 43, 117, 0.5)`,
		'&.space': {
			'&-left': {
				marginLeft: pxToEm(tipSpaceSize)
			},
			'&-right': {
				marginRight: pxToEm(tipSpaceSize)
			},
			'&-around': {
				marginLeft: pxToEm(tipSpaceSize),
				marginRight: pxToEm(tipSpaceSize)
			}
		}
	}
});